export default "__VITE_ASSET__bb1c582d__"